export default {
      id: "truckHover-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "icons.svg#truckHover",
      toString: function () {
        return this.url;
      }
    }